import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { expertBlogAPI } from '../../api/expertBlogApi'; 

// 🟢 1. Hook for fetching a SINGLE blog by ID
export function useViewBlogs(blogId: string | undefined) {
  const [blog, setBlog] = useState<any>(null);
  const [isLoadingBlog, setIsLoadingBlog] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!blogId) return;

    const fetchSingleBlog = async () => {
      setIsLoadingBlog(true);
      setError(null);
      try {
        const data = await expertBlogAPI.getBlogById(blogId);
        setBlog(data);
      } catch (err: any) {
        console.error("Failed to load blog", err);
        
        // Catch the 401 Unauthorized from your backend guard
        if (err?.response?.status === 401 || err?.status === 401) {
          toast.error("Opps! seems like you are guest user.Please login to interact with this blog");
          
          // 🟢 ADDED: 1.5 second delay so the user can read the toast before redirect!
          setTimeout(() => {
            navigate('/user-login');
          }, 1500);
          
        } else {
          setError("Could not load the article.");
        }
      } finally {
        setIsLoadingBlog(false);
      }
    };

    fetchSingleBlog();
  }, [blogId, navigate]);

  return { 
    blog, 
    setBlog, 
    isLoadingBlog, 
    error 
  };
}

// 🟢 2. Hook for fetching ALL published blogs
export function useAllBlogs() {
  const [allBlogs, setAllBlogs] = useState<any[]>([]);
  const [isLoadingBlogs, setIsLoadingBlogs] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPublishedBlogs = async () => {
      setIsLoadingBlogs(true);
      setError(null);
      try {
        const data = await expertBlogAPI.getAllPublishedBlogs();
        setAllBlogs(data || []);
      } catch (err) {
        console.error("Failed to fetch public blogs:", err);
        setError("Failed to load blogs");
      } finally {
        setIsLoadingBlogs(false);
      }
    };

    fetchPublishedBlogs();
  }, []);

  return { allBlogs, isLoadingBlogs, error };
}